import { Outlet } from 'react-router-dom';
import {
  IconNavCommandLine,
  IconNavLink,
  IconNavSparkles,
} from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { useLocale } from '../../lib/locale';
import { ag5Dict } from './i18n';
import { AG5_SCRIPTS } from './scripts';

export function Ag5Layout() {
  const t = useDict(ag5Dict);
  const { locale } = useLocale();
  useAppCrumb('ag5', t.appName, '/ag5');

  // Script entries come from the registry, so the nav cannot drift from the
  // routes. On a phone the whole group is one tab onto the script list.
  const nav: NavEntry[] = [
    {
      key: 'scripts',
      href: '/ag5',
      label: t.scripts,
      icon: IconNavCommandLine,
      end: true,
      activeOn: ['/ag5/scripts/*'],
      children: AG5_SCRIPTS.map((script) => {
        const text = script.text[locale];
        return {
          key: script.slug,
          href: `/ag5/scripts/${script.slug}`,
          label: text.navLabel ?? text.title,
        };
      }),
    },
    {
      key: 'ai-dude',
      href: '/ag5/ai-dude',
      label: t.aiDude,
      icon: IconNavSparkles,
      children: [
        { key: 'debug-wizard', href: '/ag5/ai-dude', label: t.debugWizard },
      ],
    },
    {
      key: 'links',
      href: '/ag5/links',
      label: t.links,
      icon: IconNavLink,
      children: [
        { key: 'useful-links', href: '/ag5/links', label: t.usefulLinks },
      ],
    },
  ];

  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
